import type {
  GeneralDocument,
  operations,
} from "@/providers/smarta-documents/documents-api-client";

/** The document field a general document is filed under. */
export type DocumentType = GeneralDocument["documentType"];

export type DocumentGroup = "identity" | "powers" | "tax" | "bank" | "contract";

/**
 * The nine Phase 1 document fields, in the order the lead's documents list
 * shows them, grouped as in the Phase 1 mockup.
 */
export const DOCUMENT_FIELDS: ReadonlyArray<{
  group: DocumentGroup;
  type: DocumentType;
}> = [
  { group: "identity", type: "personalausweis" },
  { group: "powers", type: "vollmacht" },
  { group: "powers", type: "partnervollmacht" },
  { group: "tax", type: "steuerunterlagen" },
  { group: "tax", type: "gewerbeanmeldung" },
  { group: "tax", type: "steuernummern" },
  { group: "bank", type: "kontoauszuege" },
  { group: "contract", type: "angebot" },
  { group: "contract", type: "preisverzeichnis" },
];

/** The only field that also takes CSV (bank exports, download only). */
export const CSV_DOCUMENT_TYPE: DocumentType = "kontoauszuege";

export const CSV_CONTENT_TYPE = "text/csv";

export interface LeadDocument {
  documentId: string;
  documentType: DocumentType;
  fileName: string;
  contentType: string;
  uploadedAt: string;
  /** smarta-accounts operator id; the page resolves it to a name. */
  uploadedByOperatorId: string;
}

/** The body smarta-documents takes to delete a general document. */
export type DeleteGeneralDocumentBody = NonNullable<
  operations["deleteApiCustomersByCustomerIdGeneral-documentsByDocumentId"]["requestBody"]
>["content"]["application/json"];

/** Why an operator deletes a file; the confirmation dialog requires one. */
export type DeletionReason = DeleteGeneralDocumentBody["deletionReason"];

/** The deletion reasons, in the order the confirmation dialog offers them. */
export const DELETION_REASONS: ReadonlyArray<DeletionReason> = [
  "wrong_field_or_lead",
  "wrong_or_duplicate_file",
  "customer_request",
];
